import { useEffect, useLayoutEffect, useState } from 'react'

import useSubtitles from '@/composables/useSubtitles'
import type { Subtitle as SubtitleType } from '@/webgl/audio/SubtitleTrack'

import Subtitle from './Subtitle'

type StandaloneSubtitlesProps = {
  time: number
  src: string
  onLoaded?: () => void
}
export default function StandaloneSubtitles({ time, src, onLoaded }: StandaloneSubtitlesProps) {
  const { loadSRT } = useSubtitles()

  const [loaded, setLoaded] = useState<boolean>(false)
  const [subtitles, setSubtitles] = useState<SubtitleType[]>([])
  const [current, setCurrent] = useState<SubtitleType | null>(null)

  useLayoutEffect(() => {
    const load = async () => {
      const subtitles = await loadSRT(src)

      setSubtitles(subtitles)
      setLoaded(true)
      onLoaded?.()
    }

    if (!loaded) {
      load()
    }
  }, [loadSRT, src, onLoaded, loaded])

  useEffect(() => {
    if (loaded) {
      const subtitle =
        time !== null ? subtitles.find((subtitle) => time >= subtitle.start && time <= subtitle.end) : null

      if (subtitle) {
        setCurrent(subtitle)
      } else {
        setCurrent(null)
      }
    }
  }, [subtitles, time, loaded])

  return (
    current && (
      <div key={current.start} className='min-h-80 px-20 flex items-center pointer-events-auto'>
        <Subtitle text={current.text} />
      </div>
    )
  )
}
